/**
 * Government Intake form wizard entry point.
 * Submit uses backend shared.routes.ts:
 * POST /v0/shared/government_intakes (publicCreateHandler) when user clicks "Submit Discovery".
 */

import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import Snackbar from '@/components/UI/Snackbar';
import { toastSelector } from '@/store';
import { WizardView } from './WizardView';

export type { ObjectType } from './hooks/wizard-helpers';

export default function GovernmentIntakeForm() {
  const snackbarRef = useRef<{ closeToast: () => void } | null>(null);
  const appToast = useSelector(toastSelector);

  useEffect(() => {
    if (appToast.showToast) {
      snackbarRef.current?.closeToast();
    }
  }, [appToast.showToast]);

  return (
    <>
      <WizardView />
      <Snackbar ref={snackbarRef} />
    </>
  );
}
